import { inject, Injectable } from "@angular/core";
import { GlobalSpinnerStore } from "../../states/global-spinner/global-spinner.store";

@Injectable({
    providedIn: 'root'
})
export class GlobalSpinnerService {

    private readonly store = inject(GlobalSpinnerStore);

    show(message: string = 'Please wait...'): void {
        this.store.show(message);
    }

    hide(): void {
        this.store.hide();
    }
}